import { render } from "./Group.vue?vue&type=template&id=1ce583f6"
import script from "./Group.vue?vue&type=script&setup=true&lang=js"
export * from "./Group.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Mask/Tiles/components/Group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ce583f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ce583f6', __exports__)) {
    api.reload('1ce583f6', __exports__)
  }
  
  module.hot.accept("./Group.vue?vue&type=template&id=1ce583f6", () => {
    api.rerender('1ce583f6', render)
  })

}


export default __exports__